<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>TÊN TRẠNG THÁI KHÔNG HỢP LỆ</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <p class="ma-0">
            <span style="color: red"
              ><i><strong>(*) Lưu ý: </strong></i></span
            >các trạng thái phải thuộc danh sách sau:
          </p>
          <ul>
            <li>Có thi</li>
            <li>Vắng thi</li>
            <li>VPQC</li>
            <li>Chưa có</li>
          </ul>
          <p class="ma-0">Các trạng thái sau đây có tên không chính xác. Xin vui lòng kiểm tra lại:</p>
          <p class="ma-0">
            {{ invalidStatus }}
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="cancel">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    invalidStatus: String,
    state: Boolean
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    }
  }
}
</script>
